import { render } from "./Mb042.vue?vue&type=template&id=7d87b982"
import script from "./Mb042.vue?vue&type=script&lang=js"
export * from "./Mb042.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__